/**
 * @generated SignedSource<<2f8946a5d058124444d4951e8dfc3231>>
 * @relayHash 6e0fe9e36c8cc9f2db588311f467fd1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bba0e9e842fd1056e59e4731676b4a75e71ff327bf182cbf0d986d06a6db3088

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceTrackType = "BRIEFING" | "NARRATION" | "%future added value";
export type ConfluenceTrackInput = {
  mainSource: string;
  supportingSources?: ReadonlyArray<string> | null | undefined;
  trackType: ConfluenceTrackType;
};
export type useRemoveTrackMutation$variables = {
  cloudId: string;
  input: ConfluenceTrackInput;
};
export type useRemoveTrackMutation$data = {
  readonly confluence_removeTrack: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useRemoveTrackMutation = {
  response: useRemoveTrackMutation$data;
  variables: useRemoveTrackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceRemoveTrackPayload",
    "kind": "LinkedField",
    "name": "confluence_removeTrack",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "ConfluenceRemoveTrackPayloadError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          },
          {
            "concreteType": "ConfluenceRemoveTrackPayloadErrorExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "statusCode"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useRemoveTrackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRemoveTrackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "bba0e9e842fd1056e59e4731676b4a75e71ff327bf182cbf0d986d06a6db3088",
    "metadata": {},
    "name": "useRemoveTrackMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0ff35a8c4dec718cbcbdba008ce5caa2";

export default node;
